"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const mui_1 = require("tss-react/mui");
const Tooltip_1 = __importDefault(require("@mui/material/Tooltip"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const Box_1 = __importDefault(require("@mui/material/Box"));
const core_1 = require("companion-app-components/utils/core");
const utils_1 = require("data/accounts/utils");
const utils_2 = require("data/transactions/utils");
const QTip_1 = __importDefault(require("components/QuickenControls/QTip"));
const AmountField_1 = __importDefault(require("components/QuickenControls/AmountField"));
const utils_3 = require("../utils");
const styles_1 = require("../styles");
const useStyles = (0, mui_1.makeStyles)()(styles_1.styles);
const BalanceField = ({ attributes, callbacks, SHOW_ALL, txn, field, lastRow, enableAutoFocus, currencySymbol, showColor, bankPendingClass, isWindowsDataset, editable, }) => {
    const { classes, theme } = useStyles();
    const showAcceptButton = (0, utils_2.isC2RTransaction)(txn);
    const handleAccept = () => {
        var _a;
        if (!txn.isReviewed) {
            core_1.tracker.track(core_1.tracker.events.txnReview, {
                isC2REnabled: isWindowsDataset ? (0, utils_1.isC2REnabledAccount)(txn.accountId) : false,
                action: 'accepted',
                count: 1,
            });
        }
        (_a = callbacks.handleMenu) === null || _a === void 0 ? void 0 : _a.call(callbacks, 'reviewed', txn);
    };
    const renderAcceptButton = () => (<Box_1.default sx={{ display: 'flex', justifyContent: 'flex-end' }}>
      <Tooltip_1.default title="This transaction hasn’t been added to your account yet. Please review and ‘Accept’ to include it in your balance." placement="bottom">
        <Button_1.default onClick={handleAccept} className={classes.acceptBalanceButton} disabled={!editable}>
          ACCEPT
        </Button_1.default>
      </Tooltip_1.default>
    </Box_1.default>);
    const renderAmountField = () => {
        var _a;
        return (
        // eslint-disable-next-line react/jsx-no-useless-fragment
        <>
      {!lastRow && (txn.balance !== null && txn.balance !== undefined) ?
                // @ts-expect-error: missing props
                <QTip_1.default wrapId={`${txn.id}-${field}`}>
          <AmountField_1.default 
                // @ts-expect-error: Property 'register' does not exist on type 'Components<BaseTheme>'.
                disableUnderline={(_a = theme.components) === null || _a === void 0 ? void 0 : _a.register.noUnderline} clickable={false} thinFont amountType="balance" 
                // @ts-expect-error: The expected type comes from property 'onChange' which is declared here on type 'IntrinsicAttributes & AmountFieldProps'
                onChange={callbacks.handleChange} onBlur={(e, type) => {
                        var _a;
                        (_a = callbacks.onAmountBlur) === null || _a === void 0 ? void 0 : _a.call(callbacks, e, type);
                    }} editable={false} autoFocus={enableAutoFocus} 
                // @ts-expect-error: Type 'string' is not assignable to type 'number'.
                value={String(txn.balance)} color={(0, utils_3.getColorName)(showColor, txn.balance)} className={(0, classnames_1.default)(classes.regInput, 'amount', classes.balanceAmount)} currencySymbol={currencySymbol}/>
        </QTip_1.default> :
                ''}
    </>);
    };
    const renderContent = () => showAcceptButton ? renderAcceptButton() : renderAmountField();
    return (<styles_1.RegListItem {...attributes} tabIndex={null} className={(0, classnames_1.default)('amount', classes.regItem, bankPendingClass)}>
      {SHOW_ALL && renderContent()}
    </styles_1.RegListItem>);
};
exports.default = BalanceField;
